import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { ArrowRight } from 'lucide-react';
import { trackEvent } from '../../lib/analytics';

export const ServicesCTA = () => (
  <div className="bg-gradient-to-r from-cyan-500 to-teal-600 rounded-2xl p-8 md:p-12 text-center text-white shadow-xl">
    <h3 className="text-3xl font-bold mb-4">Need Expert Financial Guidance?</h3>
    <p className="text-lg mb-6 text-cyan-50">
      Our team is ready to help you find the perfect financial solution for your needs
    </p>
    <Link to="/contact">
      <Button
        size="lg"
        data-testid="services-cta-btn"
        onClick={() =>
          trackEvent('cta_click', {
            event_category: 'Engagement',
            event_label: 'Schedule Consultation - Services',
          })
        }
        className="bg-white text-cyan-600 hover:bg-gray-100 shadow-lg px-8 py-6"
      >
        Schedule a Free Consultation
        <ArrowRight className="ml-2 w-5 h-5" />
      </Button>
    </Link>
  </div>
);

export default ServicesCTA;
